import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('sysmon_token');
  if (token) cfg.headers['X-SysMon-Session'] = token;
  // Always ensure Content-Type is set for POST/PUT requests
  if (['post', 'put', 'patch'].includes(cfg.method)) {
    cfg.headers['Content-Type'] = 'application/json';
  }
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('sysmon_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
